import axios from "axios";
import { useEffect, useState } from "react";

import { getCourse } from "../api/courseApi";
import type { CourseDetail } from "../types";

// Loads one course. `course` stays null when it doesn't exist; `error` means the request failed.
export const useCourse = (courseId?: string) => {
    const [course, setCourse] = useState<CourseDetail | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!courseId) {
            setLoading(false);
            return;
        }

        const controller = new AbortController();

        // Clear the previous course so it doesn't flash while the next one loads
        setCourse(null);
        setError(false);
        setLoading(true);

        getCourse(courseId, controller.signal)
            .then(setCourse)
            .catch((err) => {
                if (axios.isCancel(err)) return;
                console.error("Error fetching course:", err);
                setError(true);
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });

        return () => controller.abort();
    }, [courseId]);

    return { course, loading, error };
};